import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useState } from "react";
import { Stack } from "@mui/system";
import { TextField, Typography } from "@mui/material";
import * as Yup from "yup";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const emailSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format"),
});

export default function AddDataCaptureUser({ createDataCaptureUser }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    setError("");
    setEmail("");
  };

  const handleClose = () => {
    setOpen(false);
    setError("");
    setEmail("");
  };

  const validateEmail = async (email) => {
    try {
      await emailSchema.validate({ email });
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    // Validate email
    const isValid = await validateEmail(email);
    if (!isValid) return;

    try {
      setIsSubmitting(true);
      await createDataCaptureUser.mutateAsync({ email });
      handleClose();
    } catch (error) {
      setError(error.message || "Failed to save email");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  return (
    <React.Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        Data Capture email addresses
      </Button>
      <Dialog
        maxWidth="md"
        fullWidth
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <form onSubmit={handleSave}>
          <DialogTitle>Data Capture Email Address</DialogTitle>
          <DialogContent>
            <Stack sx={{ my: 3 }}>
              <Typography variant="body2">
                This user will receive notifications when a data capture is
                done.
              </Typography>
              <TextField
                sx={{ mt: 2 }}
                name="email"
                label="Email"
                type="email"
                value={email}
                required
                onChange={handleEmailChange}
                error={!!error}
                helperText={error}
                autoComplete="off"
                disabled={isSubmitting}
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isSubmitting || !email}
              color="primary"
              variant="contained"
            >
              {isSubmitting ? "Saving..." : "Save"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}
